export * from 'Profiles/constants/filters'

export const PROJECT_PROFILE_FETCH = 'PROJECT_PROFILE_FETCH'
export const PROJECT_PROFILE_RESET = 'PROJECT_PROFILE_RESET'
export const PROJECT_FETCH = 'PROJECT_FETCH'
export const PROJECT_FETCH_SUCCESS = 'PROJECT_FETCH_SUCCESS'
export const PROJECT_FETCH_ERROR = 'PROJECT_FETCH_ERROR'
export const PROJECT_UPDATE = 'PROJECT_UPDATE'
export const PROJECT_ARCHIVE = 'PROJECT_ARCHIVE'
export const PROJECT_UNARCHIVE = 'PROJECT_UNARCHIVE'
export const PROJECT_DELETE = 'PROJECT_DELETE'
export const PROJECT_CREATE = 'PROJECT_CREATE'
export const PROJECT_FETCH_FILES = 'PROJECT_FETCH_FILES'
export const PROJECT_UPDATE_MILESTONE_TASK = 'PROJECT_UPDATE_MILESTONE_TASK'
export const PROJECTS_UPDATE_ACTIVITY_FILTERS = 'PROJECTS_UPDATE_ACTIVITY_FILTERS'

// Filter constants for files
export const FILTER_NONE = '__NONE__'
export const FILTER_HAS_VALUE = '__HAS_VALUE__'
